import { PAGING_DEFAULT_PAGE, PAGING_DEFAULT_PAGE_SIZE } from "./constants.js";
import { SearchStatus } from "@ane/exp-data/lib/models/IFeatureSearchContext";
import { WORKSPACE_ID } from "@ane/core/lib/constants/QueryString.constants";
const featureSearchContextParams = {
  filterText: {
    paramType: "string"
  },
  [WORKSPACE_ID]: {
    paramType: "string"
  },
  keywordSearch: {
    paramType: "string",
    defaultValue: null
  },
  subscriber: {
    paramType: "string",
    defaultValue: null
  },
  experimentationGroup: {
    paramType: "enum",
    isMultiValue: true,
    defaultValue: [],
    allowAnyEnumValues: true
  },
  isolationGroups: {
    paramType: "enum",
    isMultiValue: true,
    allowAnyEnumValues: true
  },
  statuses: {
    paramType: "enum",
    defaultValue: [],
    isMultiValue: true,
    validEnumValues: Object.values(SearchStatus)
  },
  startedAfter: {
    paramType: "date",
    defaultValue: null
  },
  startedBefore: {
    paramType: "date",
    defaultValue: null
  },
  isArchived: {
    paramType: "boolean",
    defaultValue: false
  },
  page: {
    paramType: "number",
    defaultValue: PAGING_DEFAULT_PAGE
  },
  pageSize: {
    paramType: "number",
    defaultValue: PAGING_DEFAULT_PAGE_SIZE
  },
  collapseRolloutTargetsIntoRoot: {
    paramType: "boolean",
    defaultValue: true
  },
  onlyLoadFeatureData: {
    paramType: "boolean",
    defaultValue: true
  },
  dateRange: {
    paramType: "string",
    defaultValue: null
  }
};
export {
  featureSearchContextParams
};
//# sourceMappingURL=types.js.map
